import React, { useState } from 'react';
// import logo from './logo.svg';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// import Paper from '@material-ui/core/Paper';
import './App.css';
const Diff = require('diff');

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0, 1),
  },
  intro: {
    display: 'flex',
    alignItems: 'center',
  },
  numberSelect: {
    minWidth: 60,
    textAlign: 'center',
  },
  chip: {
    margin: 2,
  },
}));
function intersection() {
	var result = [];
  var lists;
  
  if(arguments.length === 1) {
  	lists = arguments[0];
  } else {
  	lists = arguments;
  }
  
  for(let i = 0; i < lists.length; i++) {
  	let currentList = lists[i];
  	for(let y = 0; y < currentList.length; y++) {
    	let currentValue = currentList[y];
      if(result.indexOf(currentValue) === -1) {
        if(lists.filter((obj) => obj.indexOf(currentValue) === -1).length === 0) {
          result.push(currentValue);
        }
      }
    }
  }
  return result;
}

const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
const App = () => {
  const classes = useStyles();
  const [lists, setLists] = useState([]);
  // const [listA, setListA] = useState('');
  // const [listB, setListB] = useState('');
  const [products, setProducts] = useState(2);

  const formatIn = (i) => i.replace(/\./g,' ').trim().toLowerCase().replace(/\s*\(?\d+%\)?/ig, '');
  const getIngredients = (l) => l.split(',').map((i) => formatIn(i)).filter((i) => i);
  const inAll = lists.map((l) => getIngredients(l));
  // const inA = getIngredients(listA);
  // const inB = getIngredients(listB);
  // const both = inA.filter((i) => inB.indexOf(i) >= 0);
  const both = inAll.length >= 2 ? intersection(inAll) : [];
  // const part = [];
  const parts = {};

  const getWords = (l) => l.toLowerCase().replace(/\//g, ' ').replace(/[()]+/ig, ' ').split(' ').map((a) => a.trim()).filter((a) => a);
  const matchWords = (l1, l2) => {
    const w1 = getWords(l1);
    const w2 = getWords(l2);
    return w1.filter((a) => w2.indexOf(a) >= 0).length / Math.max(w1.length, w2.length);
  };

  if (inAll.length > 1) {
    inAll[0].filter((l) => both.indexOf(l) < 0).forEach((l, li) => {
      inAll.slice(1).forEach((p, pi) => {
        const matches = [];
        p.filter((l) => both.indexOf(l) < 0).forEach((l2, l2i) => {
          // if (pi < inAll.length - 1) {
          // inAll[pi + 1].filter((l) => both.indexOf(l) < 0).forEach((l2, l2i) => {
          const matchedChars = Diff.diffChars(l, l2).map((d) => d.removed || d.added ? 0 : d.value.length).reduce((a, b) => a + b, 0) / Math.max(l.length, l2.length);
          const matchedWords = matchWords(l, l2);
          if (matchedChars >= 0.75 || matchedWords >= 0.5) {
            matches.push({ in: l2, match: (matchedChars + matchedWords) });
            // part.push([l, l2]); // `${l} / ${l2}`);
          }
            // console.log('Diff', l, l2, );
          // });
          // }
        }); 
        if (!parts[l]) parts[l] = [l];
        if (matches.length > 0) parts[l].push(matches.sort((a, b) => (a.match > b.match) ? -1 : 1)[0].in)
      });
      // const key = `${l}/${pi}`;
      // console.log('matches', matches);
      // parts[l] = 

    });
  }
  // console.log('lists', lists, lists.length);
  // console.log('parts', parts);
  const updateList = (product, v) => setLists((l) => [...l.slice(0, product), v, ...l.slice(product + 1)]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <p className={classes.intro}>
          Find common ingredients in 

          <FormControl className={classes.formControl}>
            <Select
              value={products}
              onChange={(event) => setProducts(event.target.value)}
              className={classes.numberSelect}
            >
              {letters.slice(1).map((l, i) => (
                <MenuItem value={i + 2} key={l}>{i + 2}</MenuItem>
              ))}
            </Select>
          </FormControl>
          products...
        </p>
      </Grid>
      {letters.slice(0, products).map((letter, product) => (
        <Grid item xs={12} md={6} key={letter}>
          <TextField
            label={`Product ${letter}`}
            multiline
            rows={4}
            value={lists[product]}
            onChange={(event) => updateList(product, event.target.value)}
            placeholder="Ingredients list (comma separated)"
            variant="outlined"
            fullWidth
          />
        </Grid>
      ))}
      <Grid item xs={12}>
        {both.map((i) => (
          <Chip
            key={i}
            label={i}
            color="primary"
            className={classes.chip}
          />
        ))}
      </Grid>
      <Grid item xs={12}>
        {Object.values(parts).filter((p) => p.length === lists.length).map((p) => [...new Set(p)].join(' / ')).map((i) => (
          <Chip
            key={i}
            label={i}
            color="secondary"
            className={classes.chip}
          />
        ))}
      </Grid>

      <Grid item xs={12} className="footer">
        <Divider />
        <p>Tool created by <a href="/download/">Skincare Routine</a>, an app for managing your skin care regimen.</p>
      </Grid>
    </Grid>
  );
}

export default App;
